import { type SubscriptionDTO } from '@klangio/ai2notes-ts-client';
import {
  D2N_SUB_ID,
  G2T_SUB_ID,
  KTS_SUB_ID,
  P2N_SUB_ID,
  S2N_SUB_ID,
  SC2N_SUB_ID,
  V2N_SUB_ID,
  W2N_SUB_ID,
  type SUB_ID_TYPES,
} from '../constants/ProductId';

const getSubIdArray = (subIds: SUB_ID_TYPES) => Object.values(subIds).map((subId) => subId);

export const filterSubscriptions = (domain: string, subscriptions: SubscriptionDTO[]) => {
  switch (domain) {
    case 'guitar2tabs':
      return subscriptions.filter(
        (sub) =>
          getSubIdArray(G2T_SUB_ID).includes(sub.productId)
          || sub.productId.includes('g2t')
          || sub.productId.includes('uni'),
      );
    case 'piano2notes':
      return subscriptions.filter(
        (sub) =>
          getSubIdArray(P2N_SUB_ID).includes(sub.productId)
          || sub.productId.includes('p2n')
          || sub.productId.includes('uni'),
      );
    case 'sing2notes':
      return subscriptions.filter(
        (sub) =>
          getSubIdArray(S2N_SUB_ID).includes(sub.productId)
          || sub.productId.includes('s2n')
          || sub.productId.includes('uni'),
      );
    case 'drum2notes':
      return subscriptions.filter(
        (sub) =>
          getSubIdArray(D2N_SUB_ID).includes(sub.productId)
          || sub.productId.includes('d2n')
          || sub.productId.includes('uni'),
      );
    case 'studio':
      return subscriptions.filter(
        (sub) =>
          getSubIdArray(KTS_SUB_ID).includes(sub.productId)
          || sub.productId.includes('studio')
          || sub.productId.includes('uni'),
      );
    case 'plugin':
      return subscriptions.filter(
        (sub) =>
          getSubIdArray(KTS_SUB_ID).includes(sub.productId)
          || sub.productId.includes('plugin')
          || sub.productId.includes('studio')
          || sub.productId.includes('uni'),
      );
    case 'scan2notes':
      return subscriptions.filter(
        (sub) =>
          ([SC2N_SUB_ID.MONTHLY, SC2N_SUB_ID.YEARLY].includes(sub.productId)
            || sub.productId.includes('sc2n'))
          && !sub.productId.includes('uni'),
      );
    case 'violin2notes':
      return subscriptions.filter(
        (sub) =>
          getSubIdArray(V2N_SUB_ID).includes(sub.productId)
          || sub.productId.includes('v2n')
          || sub.productId.includes('uni'),
      );
    case 'wind2notes':
      return subscriptions.filter(
        (sub) =>
          getSubIdArray(W2N_SUB_ID).includes(sub.productId)
          || sub.productId.includes('w2n')
          || sub.productId.includes('uni'),
      );
    default:
      return subscriptions;
  }
};

export default { filterSubscriptions };
